export default __webpack_public_path__ + "static/media/i067vp.ef25d952.webp";